import {
  AdminUsersResponseType,
  ApiClient,
  ApiErrorMessage,
  CategoryResponseType,
  MailingListResponseType,
  PhrasesResponseType,
  TrainGroupsResponseType,
  TrainsResponseType
} from './ApiClient';

export const DeleteAdminUsersApi = async (
  id: number
): Promise<AdminUsersResponseType> => {
  try {
    const response = await ApiClient.delete(
      '/admin/admin_users/' + id.toString(),
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const DeleteTrainsApi = async (
  id: number
): Promise<TrainsResponseType> => {
  try {
    const response = await ApiClient.delete('/admin/trains/' + id.toString(), {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const DeleteTrainGroupsApi = async (
  id: number
): Promise<TrainGroupsResponseType> => {
  try {
    const response = await ApiClient.delete(
      '/admin/train_groups/' + id.toString(),
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const DeleteCategoriesApi = async (
  id: number
): Promise<CategoryResponseType> => {
  try {
    const response = await ApiClient.delete(
      '/admin/categories/' + id.toString(),
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const DeletePhrasesApi = async (
  id: number
): Promise<PhrasesResponseType> => {
  try {
    const response = await ApiClient.delete('/admin/phrases/' + id.toString(), {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
      }
    });
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};

export const DeleteMailingListsApi = async (
  id: number
): Promise<MailingListResponseType> => {
  try {
    const response = await ApiClient.delete(
      '/admin/mailinglists/' + id.toString(),
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('access-token')}`
        }
      }
    );
    return { success: true, data: response.data, message: null };
  } catch (err) {
    const error = ApiErrorMessage(err);
    return { success: false, data: null, message: error?.data };
  }
};
